import React from "react";
import { Modal } from "@tecma/ds";
import { useTranslation } from "@tecma/i18n";

import { CONTACT_US_METHODS } from "../../constants";
import ContactUsCard from "../ContactUsCard";
import "./contact-us-modal.scss";

interface ContactUsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ContactUsModal: React.FC<ContactUsModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      data-testid='coliving-shareSpaceModal'
      className='contact-us-modal'
      isOpen={isOpen}
      onClose={onClose}
      verticalPosition='center'
      closeOnBackDropClick
    >
      <Modal.Header
        className='contact-us-modal__header'
        onClose={onClose}
        closeIcon
      >
        {t("contact-us-modal.title")}
      </Modal.Header>
      <Modal.Content className='contact-us-modal__content'>
        {CONTACT_US_METHODS.map((method) => (
          <ContactUsCard key={method} method={method} />
        ))}
      </Modal.Content>
    </Modal>
  );
};

export default ContactUsModal;
